import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[admClearTextDirective]',
})
export class ClearTextDirectiveDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private control = inject(NgControl);

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && document.activeElement === this.el.nativeElement) {
      this.control.control?.setValue('');
    }
  }
}
